import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

const Home = () => {
    return <Redirect to='/workflowinbox' />
}

export default connect()(Home);
